import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ServiceCTA() {
  const { t } = useTranslation();

  return (
    <section className="py-24 lg:py-32 bg-[#2d3139]">
      <div className="max-w-[900px] mx-auto px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.55, ease: [0.25, 0.46, 0.45, 0.94] }}
          className="relative rounded-[28px] overflow-hidden p-14 lg:p-20"
          style={{
            background: 'linear-gradient(135deg, rgba(0,212,255,0.10) 0%, rgba(15,20,25,0.95) 60%)',
            border: '1px solid rgba(0,212,255,0.2)',
          }}
        >
          {/* Glow */}
          <div className="absolute inset-0 pointer-events-none" style={{
            backgroundImage: 'radial-gradient(circle at 50% 0%, rgba(0,212,255,0.12) 0%, transparent 65%)'
          }}></div>

          <div className="relative z-10 flex flex-col items-center gap-6">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[rgba(0,212,255,0.15)] border border-[rgba(0,212,255,0.3)]">
              <i className="ri-mail-send-line text-[#00d4ff] text-3xl"></i>
            </div>
            <h2 className="text-white font-bold text-3xl md:text-4xl leading-tight">
              {t('servicePages.cta.title')}
            </h2>
            <p className="text-[rgba(255,255,255,0.6)] text-base md:text-lg leading-relaxed max-w-[560px]">
              {t('servicePages.cta.subtitle')}
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-4 mt-2">
              <Link
                to="/contact"
                className="px-10 py-4 rounded-[28px] bg-[#00d4ff] text-[#0f1419] font-semibold text-base hover:shadow-[0_8px_30px_rgba(0,212,255,0.4)] transition-all duration-200 flex items-center gap-2 whitespace-nowrap"
              >
                {t('servicePages.cta.btn')}
                <i className="ri-arrow-right-line text-lg"></i>
              </Link>
              <Link
                to="/"
                className="px-10 py-4 rounded-[28px] border border-[rgba(255,255,255,0.25)] text-white font-semibold text-base hover:bg-[rgba(255,255,255,0.08)] transition-all duration-200 whitespace-nowrap"
              >
                {t('servicePages.cta.back')}
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}